<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.query.userId">
    <UserWalletDetails
      slot-scope="{ data }"
      :form-data="data"
    ></UserWalletDetails>
  </l-cache>
</template>
<script>
import UserWalletDetails from "./userWalletDetails";
export default {
  name: "userWalletDetailBox",
  components: { UserWalletDetails },
  methods: {
    async getItem(key = "") {
      let pagination = { pages: 1, rowsPerPage: 10 };
      let { items, amount } = await this.$store.dispatch("pay/getUserInfo", {
        pagination: pagination,
        search: { key: "userId", value: this.$route.query.userId },
      });
      if (items.length === 0) {
        this.$L.alert("error", { message: "未查询到该用户钱包信息" });
        return {};
      } else {
        console.log(items[0]);
        return items[0];
      }
    },
  },
};
</script>
